import React from 'react'
import { Button } from '@mui/material'

export default function SidenavButton(props: SidenavButtonProps) {
  return (
    <Button
      fullWidth
      startIcon={props.icon}
      onClick={() => props.onClick(props.value)}
      sx={{
        backgroundColor: '#EFEFEF',
        ...(props.variant === 'primary' && {
          backgroundColor: '#0000FF',
          color: 'white'
        })
      }}
    >
      {props.label}
    </Button>
  )
}

interface SidenavButtonProps {
  icon: JSX.Element
  label: string
  variant: string
  value: number
  onClick: (n: number) => void
}
